/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { NgModule, Component, Input, Output, ViewChild, ViewChildren, OnDestroy,
         Renderer2,
         EventEmitter, QueryList, ElementRef, Inject } from '@angular/core';

// Ð¢ÐµÐ¿ÐµÑÑ Ð½Ð°ÑÐµ
import { ColumnType, GridPart } from '@true-directive/base';
import { UIAction, UIActionType } from '@true-directive/base';

import { Column } from '@true-directive/base';
import { ColumnBand } from '@true-directive/base';

 import { GridLayout } from '@true-directive/base';

import { BaseComponent } from './base.component';
import { ScrollerComponent } from './scroller.component';

import { GridStateService } from './grid-state.service';

import { GridHeaderCellComponent } from './grid-header-cell.component';
import { GridHeaderBandComponent } from './grid-header-band.component';

@Component({
  selector: 'true-grid-header',
  templateUrl: './grid-header.component.html',
  styleUrls: ['./styles/grid-header.behavior.scss']
})
export class GridHeaderComponent extends BaseComponent {

  @Input('layout')
  layout: GridLayout;

  @Input('scroller')
  scroller: ScrollerComponent;

  @Output('resizeColumn')
  resizeColumn = new EventEmitter<{ action: string, ui: UIAction }>();

  @Output('toggleCheckColumn')
  toggleCheckColumn = new EventEmitter<Column>();

  @ViewChild('gridHeaderTable', {static: true})
  gridHeaderTable: any;

  // ÐÐ°ÑÐºÐµÑ, ÑÐºÐ°Ð·ÑÐ²Ð°ÑÑÐ¸Ð¹ Ð½Ð¾Ð²ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°ÐµÐ¼Ð¾Ð³Ð¾ ÑÑÐ¾Ð»Ð±ÑÐ°
  @ViewChild('dropMarker', {static: true})
  dropMarker: any;  // ÐÐ¾ÐºÐ° Ð½Ðµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ, Ñ.Ðº. Ð¼Ñ Ð½Ð° Ð»ÐµÑÑ Ð¿ÐµÑÐµÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÐºÐ¾Ð»Ð¾Ð½ÐºÑ Ð¿ÑÐ¸ Ð´Ð²Ð¸Ð¶ÐµÐ½Ð¸Ð¸

  @ViewChildren('headerCell', {read: GridHeaderCellComponent}) columnElements: QueryList<GridHeaderCellComponent>;
  @ViewChildren('headerBand', {read: GridHeaderBandComponent}) bandElements: QueryList<GridHeaderBandComponent>;

  private _scrollerClientRect: any = null;

  _touches = false;
  _markerVisible = false;

  public resizeInProcess(value: boolean) {
    if (!this.gridHeaderTable) {
      return;
    }

    if (value) {
      this.gridHeaderTable.nativeElement.classList.add('true-resize-in-process');
    } else {
      this.gridHeaderTable.nativeElement.classList.remove('true-resize-in-process');
    }
  }

  public dragInProcess(value: boolean) {
    if (!this.gridHeaderTable) {
      return;
    }

    if (value) {
      this.gridHeaderTable.nativeElement.classList.add('true-drag-in-process');
    } else {
      this.gridHeaderTable.nativeElement.classList.remove('true-drag-in-process');
    }
  }

  public trackCol(i: number, c: Column) {
    return c;
  }

  //
  get isAutoScroll() {
    if (this.scroller) {
      return this.scroller.isAutoScroll;
    }
    return false;
  }

  resizeMouseUp(e: any) { }

  toggleCheck(e: any, col: Column) {
    this.toggleCheckColumn.emit(col);
  }

  headerCellMouseDown(e: any, col: Column) {
    if (e.button != 0) {
      return;
    }

    const rr = e.target.getBoundingClientRect();
    const xx = Math.round(e.clientX);

    if (xx < rr.left + rr.width / 2) {
      // ÐÐ° ÑÐ°Ð¼Ð¾Ð¼ Ð´ÐµÐ»Ðµ ÑÑÐ¾ Ð½Ðµ Ð¿ÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°Ð½Ð¸Ðµ, Ð° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ¸ÑÐ¸Ð½Ñ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐ¹ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸..
      this.resizeMouseDownPrev(e, col);
      return;
    }

    if (xx > rr.left + rr.width / 2) {
      // ÐÐ° ÑÐ°Ð¼Ð¾Ð¼ Ð´ÐµÐ»Ðµ ÑÑÐ¾ Ð½Ðµ Ð¿ÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°Ð½Ð¸Ðµ, Ð° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ¸ÑÐ¸Ð½Ñ..
      this.resizeMouseDown(e, col);
      return;
    }
  }

  captionTouchMove(e: any, col: Column) {
    //
    e.stopPropagation();

    const touches = e.changedTouches;
    if (touches.length === 1 && this.uiAction.target === col) {

      const xx = touches[0].clientX;
      const yy = touches[0].clientY;

      if (this.checkReordering(xx, yy)) {
        // ÐÐµÑÐµÐ¼ÐµÑÐµÐ½Ð¸Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾
        return;
      }

      if (this.uiAction.action === UIActionType.REORDER_COLUMN) {
        this.proceedReordering(xx, yy);
      }
    }
  }

  captionTouchEnd(e: any) {

    this.removeTouchMoveListeners();

    if (this.scroller) {
      this.scroller.stopAutoScroll();
    }

    if (!this.uiAction) {
      return;
    }

    if (this.uiAction && this.uiAction.action === UIActionType.REORDER_COLUMN) {
      this.stopReordering();
    }

    e.stopPropagation();
    if (e.cancelable) {
      e.preventDefault();
    }
  }

  captionStartDrag(e: any, col: Column) {

    if (col.isCheckbox) {
      return;
    }

    let xx: number;
    let yy: number;

    if (e.touches) {
      if (!e.changedTouches || e.changedTouches.length !== 1) {
        return;
      }

      xx = e.changedTouches[0].clientX;
      yy = e.changedTouches[0].clientY;

      this.removeTouchMoveListeners();
      this.touchMoveListenFunc = this.renderer.listen(event.target, 'touchmove', (e: any) => {
        this.captionTouchMove(e, col);
      });
      this.touchEndListenFunc = this.renderer.listen(event.target, 'touchend', (e: any) => {
        this.captionTouchEnd(e);
      });
      this.touchCancelListenFunc = this.renderer.listen(event.target, 'touchcancel', (e: any) => {
        this.captionTouchEnd(e);
      });

    } else {
      // Mouse event
      this.addDocumentMouseListeners();
      if (e.button != 0) {
        return;
      }

      xx = e.clientX;
      yy = e.clientY;
    }

    let rr = e.target.parentElement.getBoundingClientRect();

    this.uiAction = new UIAction(UIActionType.CLICK, col, xx, yy);
    this.uiAction.targetOffsetX = rr.left - xx;
    this.uiAction.targetOffsetY = rr.top - yy;

    e.stopPropagation();
  }

  captionSort(e: any, col: Column) {

    if (e.touches) {
      if (!e.changedTouches || e.changedTouches.length !== 1) {
        return;
      }
    } else {
      if (e.button != 0) {
        return;
      }
    }

    if (!this.uiAction) {
      return;
    }

    if (e.defaultPrevented) {
      return;
    }

    if (this.uiAction.target === col && this.uiAction.action === UIActionType.CLICK) {
      if (!col.isCheckbox && col.allowSorting) {
        this.state.sortByColumn(col, e.shiftKey);
        e.stopPropagation();
        e.preventDefault();
      }
      this.uiAction = null;
    }
  }

  resizeMouseDown(e: any, col: Column) {
    if (col.canResize) {
      this.initResizing(e, col);
    }
    e.stopPropagation();
  }

  resizeMouseDownPrev(e: any, col: Column) {
    let realCol = null;
    const ii = this.layout.columns.indexOf(col);

    if (ii > 0) {
      realCol = this.layout.columns[ii - 1];
      this.initResizing(e, realCol);
    }
    e.stopPropagation();
  }

  public showHeaderBtn(fieldName: string) {
    if (!this.columnElements) {
      return;
    }

    this.columnElements.forEach(el => {
      if (el.column.fieldName === fieldName) {
        el.setState('btn-visible');
      }
    });
  }

  public hideHeaderBtns() {
    if (!this.columnElements) {
      return;
    }
    this.columnElements.forEach(el => el.removeState('btn-visible'));
  }

  private get renderedColumns(): any[] {
    const renderedColumns: any[] = [];
    this.columnElements.forEach(el => {
      renderedColumns.push({ boundingRect: el.elementRef.nativeElement.getBoundingClientRect(), item: el.column });
    });
    return renderedColumns;
  }

  private get renderedBands(): any[] {
    const renderedBands: any[] = [];
    this.bandElements.forEach(el => {
      renderedBands.push({ boundingRect: el.elementRef.nativeElement.getBoundingClientRect(), item: el.band });
    });
    return renderedBands;
  }

  /**
   * ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ Ð¿ÑÐ¸ Ð¿ÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°Ð½Ð¸Ð¸ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ° ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸ Ð¸Ð»Ð¸ Ð±ÑÐ½Ð´Ð°
   * @param  mouseAction ÐÐ¾Ð·Ð¸ÑÐ¸Ñ Ð¼ÑÑÐ¸
   * @param  show        ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð»Ð¸ Ð¼Ð°ÑÐºÐµÑ
   * @return             [description]
   */
  public canDrop(mouseAction: UIAction, show: boolean): { inColumns: boolean, item: any, pos: string,  } {

    //ÐÐ´ÐµÑÑ Ð½ÑÐ¶ÐµÐ½ Ð¿ÑÑÐ¼Ð¾ÑÐ³Ð¾Ð»ÑÐ½Ð¸Ðº ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ..
    if (!this._scrollerClientRect)
      this._scrollerClientRect = this.scroller.clientRect;

    let r0 = this._scrollerClientRect;

    let hasL: boolean = false; // Ð¸Ð¼ÐµÐµÑÑÑ Ð±Ð¾Ð»ÐµÐµ Ð»ÐµÐ²Ð°Ñ ÑÐ¾ÑÑÐ°Ð²Ð»ÑÑÑÐ°Ñ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ°
    let hasR: boolean = false; // Ð¸Ð¼ÐµÐµÑÑÑ Ð±Ð¾Ð»ÐµÐµ Ð¿ÑÐ°Ð²Ð°Ñ ÑÐ¾ÑÑÐ°Ð²Ð»ÑÑÑÐ°Ñ

    if (this.layout.place === GridPart.CENTER) {
      r0 = this.scroller.headerRect;
      hasL = this.state.showFixedLeft;
      hasR = this.state.showFixedRight;
    }

    if (this.layout.place === GridPart.LEFT) {
      r0 = this.scroller.headerRectLeft;
      hasL = false;
      hasR = true;
    }

    if (this.layout.place === GridPart.RIGHT) {
      r0 = this.scroller.headerRectRight;
      hasL = true;
      hasR = false;
    }

    const tg = mouseAction.target;

    const isColumn = tg instanceof Column;
    const isBand = tg instanceof ColumnBand;
    let renderedItems: any[];

    if (isColumn) {
      renderedItems = this.renderedColumns;
    } else {
      renderedItems = this.renderedBands;
    }

    return this.layout.canDrop(mouseAction, renderedItems, r0, hasL, hasR, this.state.columnCollection);
  }

  public autoScrollX(dx: number) {
    if (this.uiAction) {
      this.uiAction.x -= dx;
    }
  }

  // ÐÐ°ÑÐ¸Ð½Ð°ÐµÐ¼ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ¸ÑÐ¸Ð½Ñ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
  initResizing(e: any, col: Column) {

    if (this.state && !this.state.settings.columnResize) {
      return;
    }

    if (col.columnResize === false) {
      return;
    }

    this.addDocumentMouseListeners();
    this.uiAction = new UIAction(UIActionType.RESIZE_COLUMN, col, e.clientX, e.clientY);
  }

  startResizing() {
    this.uiAction.initialized = true;
    this.scroller.startAutoScroll();
    this.resizeColumn.emit({ action: 'start', ui: this.uiAction });
  }

  initReordering(x: number, y: number) {
    this.uiAction.action = UIActionType.REORDER_COLUMN;
    let ww = this.uiAction.target.headerWidth;
    if (this.uiAction.target instanceof ColumnBand) {
      ww = 0;
      (<ColumnBand>this.uiAction.target).columns.forEach(c => ww += c.displayedWidth);
    }

    if (ww > 300) {
      if (this.uiAction.targetOffsetX < -250)
        this.uiAction.targetOffsetX = -150;
      ww = 300;
    }

    this.uiAction.targetWidth = ww;

    this.uiAction.initialized = true;
    this.uiAction.move(x, y);
    this.state.dragDrop.drag(this.uiAction);
  }

  proceedReordering(xx:number, yy:number) {
    this.uiAction.move(xx, yy);
    this.state.dragDrop.drag(this.uiAction);
  }

  stopReordering() {
    setTimeout(()=> {
      this.state.dragDrop.drop(this.uiAction);
      this.uiAction = null;
    });
  }

  stopActions() {
    if (this.uiAction && this.uiAction.action === UIActionType.REORDER_COLUMN) {
      this.stopReordering();
    }
  }

  /**
   * ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð¿ÐµÑÐµÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
   * @param  xx [description]
   * @param  yy [description]
   * @return    True, ÐµÑÐ»Ð¸ Ð¿ÐµÑÐµÑÑÐ°Ð½Ð¾Ð²ÐºÐ° ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð°. False - ÐµÑÐ»Ð¸
   *            Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ðµ Ð½ÑÐ¶Ð½Ð°.
   */
  checkReordering(xx: number, yy: number): boolean {
    if (this.uiAction.action === UIActionType.CLICK && this.state.settings.columnReorder) {
      if (Math.abs(xx - this.uiAction.x) > 6 || Math.abs(yy - this.uiAction.y) > 6) {
        if (this.uiAction.target instanceof Column && (<Column>this.uiAction.target).canReorder) {
          this.initReordering(xx, yy);
          return true;
        }
        if (this.uiAction.target instanceof ColumnBand && this.state.settings.bandReorder) {
          this.initReordering(xx, yy);
          return true;
        }
      }
    }
    return false;
  }

  documentMouseMove(e: MouseEvent) {

    super.documentMouseMove(e);

    if (!this.uiAction) { // ÐµÑÐ»Ð¸ ÑÑÐ¾-ÑÐ¾ Ð½Ð°ÑÐ°Ð»Ð¾ÑÑ..
      return;
    }

    const xx = e.clientX;
    const yy = e.clientY;

    if (this.checkReordering(xx, yy)) {
      return;
    }

    if (this.uiAction.action === UIActionType.REORDER_COLUMN) {
      this.proceedReordering(xx, yy);
    }

    if (!this.uiAction.initialized && this.uiAction.action === UIActionType.RESIZE_COLUMN && this.state.settings.columnResize) {
        this.startResizing();
        return;
    }

    if (this.uiAction.action === UIActionType.RESIZE_COLUMN) {
      this.uiAction.move(xx, yy);
      this.resizeColumn.emit({ action: '', ui: this.uiAction });
    }
  }

  documentMouseUp(e: MouseEvent) {

    super.documentMouseUp(e);

    if (this.scroller) {
      this.scroller.stopAutoScroll();
    }

    let xx = e.clientX;
    let yy = e.clientY;

    if (this.uiAction && this.uiAction.action === UIActionType.REORDER_COLUMN) {
      this.stopReordering();
      e.stopPropagation();
      e.preventDefault();
    }

    if (this.uiAction && this.uiAction.action === UIActionType.RESIZE_COLUMN) {

      let x0 = this.uiAction.x0;
      let x1 = xx;
      let newWidth =  this.uiAction.target.width + x1 - x0;

      if (newWidth < this.state.settings.minColumnWidthOnResize) {
        newWidth = this.state.settings.minColumnWidthOnResize;
      }

      this.state.resizeColumn(this.uiAction.target, newWidth);

      setTimeout(() => {
        this.resizeColumn.emit({ action: 'end', ui: this.uiAction });
        this.scroller.fixScroll(); // ÐÑÐ¾ÐºÑÑÑÐºÐ° Ð¼Ð¾Ð¶ÐµÑ Ð²ÑÑÐ°ÑÑ Ð² Ð½ÐµÑÐ´Ð¾Ð±Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ. Ð§Ð¸Ð½Ð¸Ð¼.
        this.uiAction = null;
      });
      e.stopPropagation();
      e.preventDefault();
    }
  }

  constructor(
    @Inject('gridState') public state: GridStateService,
    private elementRef: ElementRef,
    private renderer: Renderer2
    ) {
      super();
    }
}
